function truthyEnv(v: string | undefined): boolean {
  if (v == null) return false;
  const s = String(v).trim().toLowerCase();
  return s === "1" || s === "true" || s === "yes";
}

/** When true, show Fulfill / Reports / Admin Home manufacturing modes (scaffold UI). Default off for pilot. */
export function mfgScaffoldTabsEnabled(): boolean {
  return truthyEnv(import.meta.env.VITE_MFG_SCAFFOLD_TABS);
}
